import { Grid, Typography } from '@mui/material';
import { DraftCardMediaContainer } from '../draft-card-media-container/draft-card-media-container';
import { getImageBySize } from 'utils/helpers';
import PlayIcon from 'assets/icons/draft-play.svg';
import VideoIcon from 'assets/icons/draft-video.svg';
import { styles } from './styles';

export interface IDraftCardVideo {
  src: string;
  alt: string;
  duration: string;
}

export const DraftCardVideo = ({ src, alt, duration }: IDraftCardVideo) => {
  const imageUrl = src ? getImageBySize(src, 86, 66, false, true) : '';

  return (
    <DraftCardMediaContainer>
      <Grid sx={styles.playContainer}>
        <PlayIcon width={10} height={10} />
      </Grid>
      {imageUrl ? (
        <Grid
          component="img"
          src={imageUrl}
          alt={alt}
          sx={styles.previewImage}
        />
      ) : (
        <Grid sx={styles.placeholderContainer} />
      )}
      <Grid sx={styles.durationContainer}>
        <VideoIcon height={10} width={9} />
        <Typography sx={styles.durationTypo}>{duration}</Typography>
      </Grid>
    </DraftCardMediaContainer>
  );
};
